export default __webpack_public_path__ + "static/Tribal-6994cd729f4c235a0144e4e88b7c492a.png";